export const AI_RISK_REPORT_RENDER_MODES = {
  BROWSER: 'browser',
  EXPORT: 'export',
}

export const AI_RISK_REPORT_RENDER_MODE_VALUES = Object.values(AI_RISK_REPORT_RENDER_MODES)

export const DEFAULT_AI_RISK_REPORT_RENDER_MODE = AI_RISK_REPORT_RENDER_MODES.BROWSER

export const isAiRiskReportExportMode = (renderMode) => renderMode === AI_RISK_REPORT_RENDER_MODES.EXPORT
